export default __webpack_public_path__ + "static/media/Electric.68d1c69e.jpg";